import get from "lodash.get";
import { createListStringFromArray } from "src/utils/format_string_list_from_array";

export function payerFormatter(cell, row) {
  let payerNames = get(row, "attributes.payerNames", "");
  return payerNames.length > 0 ? createListStringFromArray(payerNames) : "N/A";
}
